// removed by extract-text-webpack-plugin
module.exports = {"base":"_2RQo7kRvf-YMPi8ZLZP7_T"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisVolumeIsGreaterThanUserBalance.scss
// module id = 1260
// module chunks = 0